"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _SZWBUSP4cjs = require('../__chunks/SZWBUSP4.cjs');


var _X22FP4G7cjs = require('../__chunks/X22FP4G7.cjs');
require('../__chunks/PLY2V46G.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tooltip/tooltip-arrow.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "div";
var useTooltipArrow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useTooltipArrow2({ store, size = 16, ...props }) {
    const context = _SZWBUSP4cjs.useTooltipContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    );
    props = _X22FP4G7cjs.usePopoverArrow.call(void 0, { store, size, ...props });
    return props;
  }
);
var TooltipArrow = _PTOCUU2Dcjs.forwardRef.call(void 0, function TooltipArrow2(props) {
  const htmlProps = useTooltipArrow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.TooltipArrow = TooltipArrow; exports.useTooltipArrow = useTooltipArrow;
